import { ToastService } from '@/app/services/toast.service';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';


@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, TegelModule],
  templateUrl: './toast.component.html',
   styleUrl: './toast.component.scss'
})
export class ToastContainerComponent {
  private toastService = inject(ToastService);
    // 直接暴露 signal
  toast = this.toastService.toast;
  show = this.toastService.show;

  // 手动关闭方法
  hide() {
    this.toastService.hideToast();
  }
  
  // 防止点击关闭（如果需要）
  preventClose(event: Event) {
    event.preventDefault();
  }
}
